import { dialog } from "../../../../../nq-component";
import BaseListPresenter from "../../../../../base/BaseListPresenter";
import DialogModal from "../../../../../components/Dialog";
import {
  format,
  startOfDay,
  addHours,
  addMinutes,
  addDays,
  parseISO,
} from "date-fns";

class WasteRawPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
  ) {
    super(view, findObjectUseCase, deleteObjectUseCase);
    this.findObjectUseCase = findObjectUseCase;
    this.countObjectUseCase = countObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.upsertUseCase = upsertUseCase;
  }

  init() {
    const user = this.view.getCurrentUser();
    const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    const storeId = user?.storeAnalytic?.[0]?.id;
    this.where = hasAdminRole ? {} : { "storeId.id": { $eq: storeId } };
    const now = Date();

    // Set to 5:00 AM of today
    const startOfBusinessDay = new Date(now);
    startOfBusinessDay.setHours(5, 0, 0, 0);

    // Set to 4:59:59.999 AM of tomorrow
    const endOfBusinessDay = new Date(now);
    endOfBusinessDay.setDate(endOfBusinessDay.getDate() + 1);
    endOfBusinessDay.setHours(4, 59, 59, 999);

    console.log("startOfBusinessDay", startOfBusinessDay);
    console.log("endOfBusinessDay", endOfBusinessDay);

    this.where = hasAdminRole
      ? {
          // category: "raw_materials",
          category: { $ne: "product" },
          isUpsale: false,
          voidDate: {
            $gte: startOfBusinessDay,
            $lte: endOfBusinessDay,
          },
        }
      : {
          "storeId.id": { $eq: storeId },
          category: { $ne: "product" },
          isUpsale: false,
          voidDate: {
            $gte: startOfBusinessDay,
            $lte: endOfBusinessDay,
          },
        };

    this.limit = 20;
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  async getObjects() {
    this.reset();
    await this.countObjects();
    await this.findObjects();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterDate,
      },
      include: this.include,
      count: true,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    // const keys = this.keys || this.view.getKeys() || [];
    // if (keys.length > 0) {
    //   query.keys = keys;
    // }
    return query;
  }

  async countObjects() {
    try {
      this.showProgress();
      const collection = this.view.getCollectionName();
      const query = this.createQuery();
      const { count } = await this.countObjectUseCase.execute(collection, {
        where: query.where,
      });
      this.count = count;
      this.view.setCount(this.count);
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
  }

  // async findObjects() {
  //   const collection = this.view.getCollectionName();
  //   const query = this.createQuery();
  //   try {
  //     this.showProgress();
  //     this.findObjectUseCase.abort();
  //     const objects = await this.findObjectUseCase.execute(collection, query);
  //     this.objects = this.objects.concat(objects);
  //     console.log("this.object", this.objects);
  //     this.view.setObjects(this.objects);
  //     this.view.setCount(this.count);
  //     this.hideProgress();
  //   } catch (error) {
  //     this.hideProgress();
  //     this.view.showError(error);
  //   }
  //   this.progress = false;
  // }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(
        "waste_records",
        query,
      );
      const objects2 = await this.findObjectUseCase.execute(
        "waste_records_manual",
        query,
      );
      this.objects = [...objects, ...objects2];
      console.log("this.object", this.objects);
      this.view.setObjects(this.objects);
      this.view.setCount(this.count);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  onChangeDate(where) {
    const { created } = where;

    if (!created || !created.$gte || !created.$lte) {
      this.filterDate = {};
      this.reset();
      this.getObjects();
      return;
    }

    const startDate = addHours(startOfDay(parseISO(created.$gte)), 5);
    const endDate = addMinutes(
      addHours(addDays(startOfDay(parseISO(created.$lte)), 0), 4),
      59,
    );

    this.filterDate = {
      requestDate: {
        $gte: startDate,
        $lte: endDate,
      },
    };

    this.getObjects();
  }

  onClickAdd() {
    this.view.navigateTo("/collection/waste_raw_materials/form");
  }

  onClickView(index) {
    const object = this.objects[index];
    this.view.navigateTo(
      "/collection/waste_raw_materials/form/" + object.id + "/view",
    );
  }

  async onClickDelete(index) {
    dialog.close();
    const object = this.objects[index];
    const collection = this.view.getCollectionName();

    await this.deleteObjectUseCase.execute(collection, object.id);
    const indexes = this.objects.indexOf(object.id);
    this.objects.splice(indexes, 1);
    this.view.setObjects(this.objects);
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Deleted Successfully"
          message=""
          isCancelButton={false}
          onSubmit={() => {
            dialog.close();
          }}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  async onCancelSubmit(index) {
    const collection = this.view.getCollectionName();

    const object = this.objects[index];

    const updatePayload = {
      id: object.id,
      status: "Cancelled",
    };

    console.log("object", updatePayload);
    await this.upsertUseCase.execute(collection, updatePayload);
    this.getObjects();
    dialog.close();
  }

  onReceiveAll(index) {
    const object = this.view.state.objects[index];
    this.view.navigateTo(
      "/collection/stock_request/form/" + object.id + "/receive",
    );
    dialog.close();
  }

  onPartialReceive(index) {
    const object = this.view.state.objects[index];
    this.view.navigateTo(
      "/collection/stock_request/form/" + object.id + "/partial",
    );
    dialog.close();
  }
  onClickImport() {}
  onClickExport() {}
}

export default WasteRawPresenter;
